import React from "react";
import {
  Workspaces,
  Badge,
  Architecture,
  AutoAwesomeMosaic,
  Group,
  Policy,
  PresentToAll,
  PrivacyTip,
  RemoveFromQueue,
  PeopleAlt,
  AccountBalanceWallet,
  CreditCard,
  Sell,
  PersonAddAlt,
  Groups,
  ModeStandby,
  DateRange,
  AllInclusive,
  People,
  NoAccounts,
  SettingsAccessibility,
  Savings,
} from "@mui/icons-material";
import Category from "@mui/icons-material/Category";
import Rule from "@mui/icons-material/Rule";
import Numbers from "@mui/icons-material/Numbers";
import Payments from "@mui/icons-material/Payments";

export const leaveTypeHeader = [
  { name: "Leave Type", key: "name" },
  { name: "Color Code", key: "leave_color" },
  { name: "No of Configurations", key: "no_of_configuration" },
  { name: "Actions", key: "action" },
];
export const viewLeaveTypeDetails = [
  {
    name: "Version",
    key: "version",
  },
  {
    name: "Effective From",
    key: "effective_from",
  },
  {
    name: "Effective To",
    key: "effective_to",
  },
  {
    name: "Proportions Leaves on join date",
    key: "proportionate_leaves_on_joined_date",
  },
  {
    name: "Is This Leave type paid",
    key: "is_paid_leave",
  },
  {
    name: "Payment Factor",
    key: "payment_factor",
  },
  {
    name: "Leave Crediting Schedule",
    key: "leave_crediting_schedule",
  },
  {
    name: "Leave Per Leave Period",
    key: "leave_per_leave_period",
  },
  {
    name: "Is Week-off Sandwich Leave",
    key: "is_week_off_rule_apply",
  },
  {
    name: "Is Holiday Sandwich Leave",
    key: "is_holiday_rule_apply",
  },
  {
    name: "Leave Payout Policy",
    key: "leave_pay_out_policy",
  },
  {
    name: "Carryforward Days",
    key: "no_of_days_leave_carry_forward",
  },
  {
    name: "Duration in Month",
    key: "expiry_month",
  },
  {
    name: "Last Credited Date",
    key: "last_credited_date",
  },
  {
    name: "Action",
    key: "action",
  },
];

export const scheduleMultiplier = {
  Annually: 1,
  Quarterly: 4,
  "Half Yearly": 2,
  Monthly: 12,
};

export const monthNumber = [
  { label: "1" },
  { label: "2" },
  { label: "3" },
  { label: "4" },
  { label: "5" },
  { label: "6" },
  { label: "7" },
  { label: "8" },
  { label: "9" },
  { label: "10" },
  { label: "11" },
  { label: "12" },
];

export const assignHeader = [
  {
    name: "",
    key: "check_box",
  },
  {
    name: "",
    key: "arrow_down",
  },
  {
    name: "Employee Id",
    key: "employee_id",
  },
  {
    name: "Employee Name",
    key: "user_name",
  },
  {
    name: "Leave Group",
    key: "leave_group_name",
  },
  {
    name: "Effective From",
    key: "effective_from",
  },
  {
    name: "Effective To",
    key: "effective_to",
  },
  {
    name: "Action",
    key: "",
  },
];

export const individualAssignHeader = [
  {
    name: "Employee Id",
    key: "employee_id",
  },
  {
    name: "Employee Name",
    key: "user_name",
  },
  {
    name: "Leave Group",
    key: "leave_group_name",
  },
  {
    name: "Effective From",
    key: "effective_from",
  },
  {
    name: "Effective To",
    key: "effective_to",
  },
  // {
  //   name: "Action",
  //   key: "",
  // },
];

export const individualLeaveGroupDetails = [
  {
    name: "Leave Type",
    key: "leave_type_name",
  },
  {
    name: "Annual Allowance",
    key: "annual_allowance",
  },
  {
    name: "Total Credited",
    key: "credited_leave",
  },
  {
    name: "Total Planned",
    key: "planned_leave",
  },
  {
    name: "Taken Leave",
    key: "used_leave",
  },
  {
    name: "Balance",
    key: "available_leave",
  },
  {
    name: "Expiry Date",
    key: "expiry_date",
  },
];

export const salaryComponentHeader = [
  {
    name: "Name",
    key: "name",
    type: "autocomplete",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Type",
    key: "component_type",
    type: "autocomplete",
    icon: <Category fontSize="small" />,
  },
  {
    name: "Category",
    key: "component_category",
    type: "autocomplete",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "Code",
    key: "code",
    type: "autocomplete",
    icon: <Architecture fontSize="small" />,
  },
  {
    name: "Method",
    key: "computation_method",
    type: "autocomplete",
    icon: <AutoAwesomeMosaic fontSize="small" />,
  },
  {
    name: "Employees",
    key: "employee_count",
    type: "number",
    icon: <Group fontSize="small" />,
  },
  {
    name: "Gross",
    key: "include_in_gross",
    type: "boolean",
    icon: <RemoveFromQueue fontSize="small" />,
  },
  {
    name: "CTC",
    key: "include_in_ctc",
    type: "boolean",
    icon: <Policy fontSize="small" />,
  },
  {
    name: "TDS",
    key: "include_in_tds",
    type: "boolean",
    icon: <PresentToAll fontSize="small" />,
  },
  {
    name: "Show in payslip",
    key: "show_in_payslip",
    type: "boolean",
    icon: <PrivacyTip fontSize="small" />,
  },
  {
    name: "Status",
    key: "status",
    type: "autocomplete",
    icon: <ModeStandby fontSize="small" />,
  },
];

export const salaryTempateHeader = [
  {
    name: "Name",
    key: "template_name",
    type: "autocomplete",
    icon: <PeopleAlt fontSize="small" />,
  },
  {
    name: "Salary Type",
    key: "salary_type",
    type: "autocomplete",
    icon: <Workspaces fontSize="small" />,
  },

  {
    name: "Employee Count",
    key: "employee_count",
    type: "number",
    icon: <AccountBalanceWallet fontSize="small" />,
  },
  {
    name: "Gross Salary",
    key: "salary",
    type: "number",
    icon: <CreditCard fontSize="small" />,
  },

  {
    name: "Status",
    key: "status",
    type: "autocomplete",
    icon: <Sell fontSize="small" />,
  },
];

export const componentGroupViewHeader = [
  {
    name: "",
    key: "Action",
  },
  {
    name: "Name",
    key: "name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "No of Employees",
    key: "employee_count",
    type: "number",
    icon: <PersonAddAlt fontSize="small" />,
  },
  // {
  //   name: "View",
  //   key: "view",
  //   Viewmode: true,
  //   icon: <Visibility fontSize="small" />,
  // },
];

export const IndividualUserComponentHeader = [
  {
    name: "Employee ID",
    key: "employee_id",
  },
  {
    name: "Employee Name",
    key: "user_name",
  },
  {
    name: "Department",
    key: "department",
  },
  {
    name: "Designation",
    key: "designation",
  },
  {
    name: "Effective From",
    key: "effective_from",
  },
  {
    name: "Effective To",
    key: "effective_to",
  },
];

export const componentEmployeeViewHeader = [
  {
    name: "Employee Name",
    key: "employee_name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "Employee id",
    key: "employee_id",
    type: "string",
    icon: <Badge fontSize="small" />,
  },

  {
    name: "Department",
    key: "department",
    type: "autocomplete",
    icon: <Groups fontSize="small" />,
  },
  {
    name: "Designation",
    key: "designation",
    type: "autocomplete",
    icon: <ModeStandby fontSize="small" />,
  },

  {
    name: "Effective From",
    key: "effective_from",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "effective_from",
      toField: "effective_to",
    },
  },
  {
    name: "Effective To",
    key: "effective_to",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "effective_from",
      toField: "effective_to",
    },
  },
];

export const templateGroupViewHeader = [
  {
    name: "",
    key: "Action",
  },
  {
    name: "Template Name",
    key: "template_name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "No of Employees",
    key: "total_employees",
    type: "number",
    icon: <People fontSize="small" />,
  },
  {
    name: "Non-Override Employee",
    key: "non_override",
    type: "number",
    icon: <SettingsAccessibility fontSize="small" />,
  },
  {
    name: "Override Employee",
    key: "override",
    type: "number",
    icon: <NoAccounts fontSize="small" />,
  },
];

export const templateEmployeeViewHeader = [
  {
    name: "Employee Name",
    key: "employee_name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "Employee id",
    key: "employee_id",
    type: "string",
    icon: <Badge fontSize="small" />,
  },

  {
    name: "Department",
    key: "department",
    type: "autocomplete",
    icon: <Groups fontSize="small" />,
  },
  {
    name: "Designation",
    key: "designation",
    type: "autocomplete",
    icon: <ModeStandby fontSize="small" />,
  },

  {
    name: "Template Name",
    key: "template_name",
    type: "string",
    icon: <AllInclusive fontSize="small" />,
  },

  {
    name: "Effective From",
    key: "effective_from",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "effective_from",
      toField: "effective_to",
    },
  },
  {
    name: "Effective To",
    key: "effective_to",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "effective_from",
      toField: "effective_to",
    },
  },
];

export const templateLogHeader = [
  {
    name: "Template Name",
    key: "template_name",
  },
  {
    name: "Current Salary",
    key: "salary",
  },
  {
    name: "Effective From",
    key: "effective_from",
  },
  {
    name: "Effective To",
    key: "effective_to",
  },
];

export const salaryRevisionGroupedHeader = [
  {
    name: "Name",
    key: "employee_name",
  },
  {
    name: "Emp Id",
    key: "employee_id",
  },
  {
    name: "Dept",
    key: "department_name",
  },
  {
    name: "Old Salary",
    children: [
      { name: "Previous Salary", key: "previous_salary" },
      { name: "Template Name", key: "previous_template_name" },
      { name: "Effective From", key: "previous_effective_from" },
    ],
  },
  {
    name: "New Salary",
    children: [
      { name: "Current Salary", key: "new_salary" },
      { name: "Template Name", key: "new_template_name" },
      { name: "Effective From", key: "effective_from" },
    ],
  },
];

export const salaryRevisionHeader = [
  {
    name: "Name",
    key: "employee_name",
    type: "string",
    icon: <People fontSize="small" />,
  },
  {
    name: "Emp Id",
    key: "employee_id",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Dept",
    key: "department_name",
    type: "autocomplete",
    icon: <Workspaces fontSize="small" />,
  },

  {
    name: "Previous Salary",
    key: "previous_salary",
    type: "number",
    icon: <Savings fontSize="small" />,
  },
  {
    name: "Old Template Name",
    key: "previous_template_name",
    type: "autocomplete",
    icon: <DateRange fontSize="small" />,
  },
  {
    name: "Effective From",
    key: "previous_effective_from",
    type: "date",
    icon: <DateRange fontSize="small" />,
  },
  {
    name: "Current Salary",
    key: "new_salary",
    type: "number",
    icon: <Savings fontSize="small" />,
  },
  {
    name: "New Template Name",
    key: "new_template_name",
    type: "autocomplete",
    icon: <DateRange fontSize="small" />,
  },
  {
    name: "Effective From",
    key: "effective_from",
    type: "date",
    icon: <DateRange fontSize="small" />,
  },
];

export const salaryRevisionTableHeader = [
  {
    name: "Name",
    key: "employee_name",
  },
  {
    name: "Emp Id",
    key: "employee_id",
  },
  {
    name: "Dept",
    key: "department_name",
  },
  {
    name: "Old Salary",
    children: [
      { name: "Previous Salary", key: "salary" },
      { name: "Template Name", key: "template_name" },
      { name: "Effective From", key: "effective_from" },
    ],
  },
  {
    name: "New Salary",
    children: [
      { name: "Current Salary", key: "salary" },
      { name: "Template Name", key: "template_name" },
      { name: "Effective From", key: "effective_from" },
    ],
  },
];

export const salaryTableHeader = [
  {
    name: "Name",
    key: "employee_name",
    type: "string",
    icon: <People fontSize="small" />,
  },
  {
    name: "Emp Id",
    key: "employee_id",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Dept",
    key: "department_name",
    type: "autocomplete",
    icon: <Workspaces fontSize="small" />,
  },

  {
    name: "Previous Salary",
    key: "salary",
    type: "number",
    icon: <Savings fontSize="small" />,
  },
  {
    name: "Old Template Name",
    key: "template_name",
    type: "autocomplete",
    icon: <DateRange fontSize="small" />,
  },
  {
    name: "Effective From",
    key: "effective_from",
    type: "date",
    icon: <DateRange fontSize="small" />,
  },
  {
    name: "Current Salary",
    key: "salary",
    type: "number",
    icon: <Savings fontSize="small" />,
  },
  {
    name: "New Template Name",
    key: "template_name",
    type: "autocomplete",
    icon: <DateRange fontSize="small" />,
  },
  {
    name: "Effective From",
    key: "effective_from",
    type: "date",
    icon: <DateRange fontSize="small" />,
  },
];

export const incentivesTableHeader = [
  {
    name: "Name",
    key: "name",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Type",
    key: "incentive_type",
    type: "autocomplete",
    icon: <Category fontSize="small" />,
  },
  {
    name: "Qualification Condition",
    key: "qualification_type",
    type: "autocomplete",
    icon: <Rule fontSize="small" />,
  },
  {
    name: "Qualification Value",
    key: "qualification_value",
    type: "number",
    icon: <Numbers fontSize="small" />,
  },
  {
    name: "Payout Type",
    key: "payout_type_display",
    type: "autocomplete",
    icon: <Payments fontSize="small" />,
  },
  {
    name: "Payout Value",
    key: "payout_value",
    type: "number",
    icon: <Payments fontSize="small" />,
  },
];

export const incentiveType = [
  {
    label: "Attendance",
  },
  {
    label: "OverTime",
  },
  // {
  //   label: "Task/Performance",
  // },
];

export const qualificationCondition = [
  {
    label: "Percentage",
  },
  {
    label: "Count",
  },
];

export const payoutType = [
  {
    label: "Fixed amount",
  },
  {
    label: "% of salary",
  },
];

export const payoutBasis = [
  {
    label: "Per day",
  },
  {
    label: "Per cycle",
  },
];

export const EligibilityType = [
  {
    id: 1,
    name: "Department",
  },
  {
    id: 2,
    name: "Designation",
  },
  {
    id: 3,
    name: "Role",
  },
  {
    id: 4,
    name: "Individual",
  },
];

export const HREmployeeTable = [
  {
    name: "Employee name",
    key: "user_name",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Employee ID",
    key: "employee_id",
    type: "string",
    icon: <Category fontSize="small" />,
  },
  {
    name: "User Code",
    key: "user_code",
    type: "string",
    icon: <Rule fontSize="small" />,
  },
  {
    name: "Department",
    key: "department",
    type: "string",
    icon: <Numbers fontSize="small" />,
  },
  {
    name: "Email id",
    key: "email",
    type: "string",
    icon: <Payments fontSize="small" />,
  },
  {
    name: "Status",
    key: "status",
    type: "string",
    icon: <Payments fontSize="small" />,
  },
  {
    name: "Action",
    key: "",
  },
];

// export const HREmployeeTable = [
//   {
//     name: "Employee name",
//     key: "name",
//     type: "string",
//     icon: <Badge fontSize="small" />,
//   },
//   {
//     name: "Employee id",
//     key: "employee_id",
//     type: "string",
//     icon: <Category fontSize="small" />,
//   },
//   {
//     name: "User Code",
//     key: "user_code",
//     type: "string",
//     icon: <Rule fontSize="small" />,
//   },
//   {
//     name: "Department",
//     key: "department",
//     type: "string",
//     icon: <Numbers fontSize="small" />,
//   },
//   {
//     name: "Company Name",
//     key: "company_name",
//     type: "string",
//     icon: <Payments fontSize="small" />,
//   },
//   {
//     name: "Email id",
//     key: "email",
//     type: "string",
//     icon: <Payments fontSize="small" />,
//   },
//   {
//     name: "Status",
//     key: "status",
//     type: "string",
//     icon: <Payments fontSize="small" />,
//   },
//   {
//     name: "Action",
//     key: "",
//   },
// ];
